
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy, Link } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The Harmonised group 1 site header is present on every page. It communicates
  the European Commission brand and provides basic structure and guidance, to be
  placed at the top of the page.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/HarmonisedTemplate/harmonised-1-site-header.png" alt="Anatomy of harmonised group 1 site header" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} system="ec" selectedKind="components-site-headers-harmonised" selectedStory="group-1" mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Component`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`European Commission logo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Logo of the European Commission`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Login`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual`}{` `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Login component for ECAS account`}<br />{`*`}{` use a Login component if your website has a user database`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Language select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual`}{` `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Language select component through which users can select their desired language, on the left of the search form`}<br />{`*`}{` use a Language select component if your website supports multilingual content`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><Link to="/ec/components/forms/search-form/usage/" standalone mdxType="Link">{`Europa search form`}</Link></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual`}{` `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Enables the user to search and retrieve related information from the database using keywords`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Class name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual`}{` `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Banner indicating the parent class under which the site falls`}<br />{`*`}{` use a Class name component if the website you are creating or updating falls under one of the classes on the `}<Link to="/ec/core-template/" mdxType="Link">{`Core site`}</Link></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Site name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the site`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Horizontal menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contextual`}{` `}{`*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Main navigation of the website`}</td>
        </tr>
      </tbody>
    </table>
    <Paragraph size="s" mdxType="Paragraph">
  * <strong>Contextual</strong> – elements that may or may not feature on a
  page, depending on the communication and/or functional needs – for example,
  Login. Where the element features, use the ECL component.
    </Paragraph>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`ensure the pages contain all the elements in the anatomy table above`}</li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul">{`don't use more than one Site header per page`}</li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`always use a Site header when building your page`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`do not follow these guidelines when you are updating sites that fall under the `}<Link to="/ec/standardised-template/" mdxType="Link">{`Standardised`}</Link>{` or `}<Link to="/ec/core-template/" mdxType="Link">{`Core`}</Link>{` category`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;